import { enLongTail } from "./en-long-tail";
import { enVrat } from "./en-vrat";
export interface PageMeta {
  title: string;
  description: string;
  keywords?: string[];
  ogTitle?: string;
  ogDescription?: string;
}

const en: Record<string, PageMeta> = {
  panchang: {
    title: "Today's Panchang | Aaj Ka Panchang | Ishvaram",
    description:
      "Aaj Ka Panchang — today's Tithi, Nakshatra, Yoga, Karana, and Rahu Kaal. Free daily Panchang with accurate planetary positions and auspicious timings for your city.",
    keywords: [
      "today panchang",
      "aaj ka panchang",
      "hindu calendar today",
      "tithi today",
      "nakshatra today",
      "panchang 2026",
      "daily panchang",
      "todays panchangam",
      "panchangam today",
      "panchangam",
    ],
    ogTitle: "Today's Panchang | Aaj Ka Panchang | Ishvaram",
    ogDescription:
      "Aaj Ka Panchang — today's Tithi, Nakshatra, Yoga, Karana with accurate timings. 100% free.",
  },
  rashifal: {
    title: "Aaj Ka Rashifal Today — 12 Rashi Daily Horoscope | Ishvaram",
    description:
      "Aaj ka rashifal for every rashi — Mesh, Vrishabh, Mithun and 9 more. Free daily horoscope from live planetary transits, in Hindi and English. Updated every morning.",
    keywords: [
      "aaj ka rashifal",
      "rashifal",
      "rashifal 2026",
      "today rashifal",
      "daily horoscope",
      "rashi horoscope",
      "rashifal today",
      "aaj ka rashifal 2026",
    ],
    ogTitle: "Aaj Ka Rashifal — Today's 12 Rashi Horoscope | Ishvaram",
    ogDescription:
      "Free daily rashifal for all 12 rashi. Live planetary transits, Hindi + English.",
  },
  "free-kundali": {
    title: "Free Kundli Online — Janam Kundali by Date of Birth | Ishvaram",
    description:
      "Make your free Kundli (Janam Kundali) by date of birth — full birth chart with 12 houses, 9 planets, Rashi, Nakshatra, Dasha periods, and Mangal Dosh & Kaal Sarp Dosh check, plus an AI reading.",
    keywords: [
      "free kundli online",
      "janam kundali",
      "kundali by date of birth",
      "birth chart",
      "free kundali",
      "kundli online",
      "janam kundali by date of birth",
    ],
    ogTitle: "Free Kundli Online | Janam Kundali Birth Chart | Ishvaram",
    ogDescription:
      "Free Kundli (Janam Kundali) by date of birth — 9 planets, 12 houses, dosha check, dasha timeline, AI reading.",
  },
  "kundli-matching": {
    title: "Free Kundli Matching — 36 Gun Milan + Mangal Dosh Check | Ishvaram",
    description:
      "Free Kundli Matching with the full 36-Gun Milan (Ashtakoot) score, Mangal Dosh + Nadi Dosh check, and a clear marriage verdict — built from your birth chart, not a generic number.",
    keywords: [
      "kundli matching",
      "gun milan",
      "kundali matching",
      "marriage compatibility",
      "ashtakoot",
      "36 gun milan",
      "patrika matching",
      "janmakshar matching",
      "match making kundali",
      "kundali matching for marriage",
      "kundli milan",
      "calculating yoni kuta",
      "mpanchang kundali matching",
    ],
    ogTitle: "Kundli Matching — 36-Point Gun Milan in 60s | Ishvaram",
    ogDescription:
      "Free 36-point Gun Milan + Mangal Dosha + Nadi dosha — marriage compatibility verdict in seconds.",
  },
  "ai-astrologer": {
    title: "Free AI Astrologer | Chat with AI Jyotishi Online | Ishvaram",
    description:
      "Chat with India's most accurate AI astrologer. Get instant Vedic birth chart analysis, dosha detection, dasha predictions, and personalized remedies — 100% free.",
    keywords: [
      "AI astrologer",
      "ai jyotish",
      "online astrologer",
      "vedic astrology ai",
      "free astrology chat",
    ],
    ogTitle: "Free AI Astrologer | Chat with AI Jyotishi | Ishvaram",
    ogDescription:
      "Chat with India's AI astrologer — instant kundali analysis, doshas, dasha predictions. Free.",
  },
  "free-astrology-chat": {
    title: "Free Astrology Chat — No Per-Minute Charges, 24/7 | Ishvaram",
    description:
      "Free astrology chat with an AI Jyotishi — no per-minute charges, no waiting. Get your kundali, dosha analysis, dasha predictions, and upay instantly. Your AI Jyotishi is available 24/7.",
    keywords: [
      "free astrology chat",
      "free astrology chat online",
      "astrology chat free",
      "free chat with astrologer",
      "online astrology chat",
      "ai jyotish chat",
      "free kundali chat",
    ],
    ogTitle: "Free Astrology Chat — No Per-Minute Charges | Ishvaram",
    ogDescription:
      "Chat with an AI Jyotishi for free — kundali, dosha, upay, rashifal. No per-minute charges. Available 24/7.",
  },
  astrologers: {
    title: "AI Astrologer Online | Free Vedic AI Jyotishi (Pandit-ji) | Ishvaram",
    description:
      "Meet Ishvaram's AI Vedic astrologer — grounded in Parashari Jyotish, it reads your full chart and answers any question. Free, 24/7, no queue.",
    keywords: [
      "AI astrologer",
      "online astrologer",
      "talk to astrologer",
      "free astrologer chat",
      "vedic astrologer",
      "jyotishi online",
    ],
    ogTitle: "Free AI Astrologer — Talk Now | Ishvaram",
    ogDescription:
      "Your Vedic AI astrologer — Parashari Jyotish, full chart reading. Free chat, 24/7, your chart loaded.",
  },
  pandits: {
    title: "AI Pandit Ji Online | Free Vedic Remedies & Muhurat | Ishvaram",
    description:
      "Consult AI Pandit Ji online for free — dosha remedies, shubh muhurat, puja guidance, classical Vedic shastra. Trained in the Kashi Parashari parampara.",
    keywords: [
      "pandit",
      "pandit ji",
      "online pandit",
      "ai pandit",
      "pandit for puja",
      "dosha remedies",
      "shubh muhurat",
      "vedic pandit",
    ],
    ogTitle: "AI Pandit Ji — Free Remedies + Muhurat | Ishvaram",
    ogDescription:
      "Consult AI Pandit Ji for dosha nivaran, shubh muhurat, and classical Vedic guidance. Free.",
  },
  "talk-to-astrologer": {
    title: "Talk to Astrologer Free | AI Jyotishi, No Per-Minute Charges | Ishvaram",
    description:
      "Talk to an astrologer free — Ishvaram's AI Jyotishi reads your kundali and answers about dosha, dasha, career, marriage, and upay with no per-minute meter. Available 24/7.",
    keywords: [
      "talk to astrologer",
      "talk to astrologer free",
      "talk to astrologer online",
      "free astrologer",
      "ask astrologer free",
      "online astrologer free",
    ],
    ogTitle: "Talk to an Astrologer Free — AI Jyotishi 24/7 | Ishvaram",
    ogDescription:
      "Talk to an astrologer free — kundali, dosha, dasha, upay. No per-minute charges. Available 24/7.",
  },
  "chat-with-astrologer": {
    title: "Chat with Astrologer Online Free | Instant AI Jyotishi | Ishvaram",
    description:
      "Chat with an astrologer online free — Ishvaram's AI Jyotishi answers kundali, dosha, dasha, and upay questions instantly, with no per-minute meter and no queue. Available 24/7.",
    keywords: [
      "chat with astrologer",
      "chat with astrologer free",
      "chat with astrologer online",
      "online astrologer chat",
      "astrologer chat free",
      "free chat astrologer",
    ],
    ogTitle: "Chat with an Astrologer Online Free — Instant | Ishvaram",
    ogDescription:
      "Chat with an astrologer online free — instant kundali, dosha, dasha, upay answers. No meter, no queue.",
  },
  "astrologer-for-marriage-problem": {
    title: "Astrologer for Marriage Problem | Free AI Jyotishi Reads 7th House | Ishvaram",
    description:
      "Talk to an astrologer about your marriage problem free. The AI Jyotishi reads your 7th house, Shukra, and Mangal Dosh, names the planetary cause, and gives the upay — no per-minute charges.",
    keywords: [
      "astrologer for marriage problem",
      "marriage problem astrologer",
      "marriage problem solution astrology",
      "astrology for marriage delay",
      "mangal dosh marriage problem",
      "love marriage problem astrologer",
    ],
    ogTitle: "Astrologer for Marriage Problem — Free 7th House Read | Ishvaram",
    ogDescription:
      "Free AI Jyotishi reads your 7th house, Shukra, and Mangal Dosh behind a marriage problem, with the upay.",
  },
  "career-astrology-consultation": {
    title: "Career Astrology Consultation Free | AI Jyotishi Reads 10th House | Ishvaram",
    description:
      "Free career astrology consultation — the AI Jyotishi reads your 10th house, D10, active dasha, and Shani/Guru transits to show what blocks career growth and the upay. No per-minute charges.",
    keywords: [
      "career astrology consultation",
      "career astrology",
      "career prediction astrology free",
      "job astrology consultation",
      "career problem astrologer",
      "astrology for career growth",
    ],
    ogTitle: "Career Astrology Consultation Free — 10th House Read | Ishvaram",
    ogDescription:
      "Free career consultation — AI Jyotishi reads your 10th house, dasha, and transits, with the career upay.",
  },
  choghadiya: {
    title: "Aaj Ka Choghadiya Today — Live Shubh Muhurat for Your City | Ishvaram",
    description:
      "Today's Choghadiya — Amrit, Shubh, Labh, Char times auto-detected for your city (Delhi, Mumbai, Bengaluru + 200 cities). Day & night muhurat table updated live at sunrise. Free, no login.",
    keywords: [
      "choghadiya",
      "aaj ka choghadiya",
      "choghadiya today",
      "shubh choghadiya",
      "choghadiya time",
      "choghadiya for today",
    ],
  },
  "rahu-kaal": {
    title: "Rahu Kaal Today | Rahu Kalam Time | Ishvaram",
    description:
      "Today's Rahu Kaal timing for your city. Check accurate Rahu Kalam, Yamagandam, and Gulika Kaal times calculated from sunrise.",
    keywords: ["rahu kaal", "rahu kaal today", "rahu kalam", "rahu kaal time", "yamagandam"],
  },
  muhurat: {
    title: "Shubh Muhurat {year} — Marriage, Griha Pravesh & More | Ishvaram",
    description:
      "Find shubh muhurat {year} for marriage, griha pravesh, vehicle, business, mundan, and 6 more events. Panchang-based auspicious dates with Nakshatra and Tithi — free complete guide.",
    keywords: [
      "shubh muhurat {year}",
      "muhurat today",
      "auspicious timing",
      "abhijit muhurat",
      "griha pravesh muhurat {year}",
      "marriage muhurat {year}",
      "shubh muhurat for marriage",
    ],
  },
  numerology: {
    title: "Ank Jyotish — Mulank, Bhagyank & Lucky Number Calculator (Free) | Ishvaram",
    description:
      "Ank Jyotish (Vedic numerology) in 60 seconds — find your Mulank, Bhagyank and Naam Ank, the planet ruling each number, and the upay that aligns it with your kundali.",
    keywords: ["numerology calculator", "mulank", "bhagyank", "numerology free", "name numerology"],
  },
  "name-numerology": {
    title: "Name Numerology Calculator | Find Your Name Number | Ishvaram",
    description:
      "Free Name Numerology Calculator — enter your name to find your Name Number (1-9). Understand personality traits and destiny based on the Chaldean (Vedic) numerology system.",
    keywords: [
      "name numerology",
      "name number calculator",
      "numerology name",
      "name meaning numerology",
    ],
  },
  "mulank-calculator": {
    title: "Mulank Calculator — Find Your Root Number by Date of Birth (Free) | Ishvaram",
    description:
      "Why do the same patterns keep repeating? Your Mulank — the root number from your birth day — is the reason. Free Mulank calculator: enter your date of birth to find your Mulank (1-9), its ruling Graha, and your upay.",
    keywords: [
      "mulank calculator",
      "how to calculate mulank",
      "how to find mulank",
      "mulank calculation",
      "mulank calculator by date of birth",
      "what is my mulank",
    ],
  },
  "bhagyank-calculator": {
    title: "Bhagyank Calculator — Find Your Destiny Number by Date of Birth (Free) | Ishvaram",
    description:
      "Why does your hard work never turn into the life you expected? Your Bhagyank — the destiny number from your birth date — maps your path. Free Bhagyank calculator: find your Bhagyank (1-9), ruling planet, and upay.",
    keywords: [
      "bhagyank calculator",
      "how to calculate bhagyank",
      "how to find bhagyank",
      "bhagyank calculation",
      "bhagyank",
      "mulank and bhagyank calculator",
    ],
  },
  "baby-names": {
    title: "Baby Names by Nakshatra | Numerology Score | Ishvaram",
    description:
      "Find the perfect baby name by nakshatra and numerology. 1500+ authentic Sanskrit names with Hindi meanings, starting syllables, and numerology scores.",
    keywords: [
      "baby names by nakshatra",
      "nakshatra baby names",
      "hindu baby names",
      "sanskrit baby names",
      "suggest names of newly born baby",
      "saasu to akshar se naam",
    ],
  },
  "ascendant-calculator": {
    title: "Lagna Calculator — Ascendant by Birth Date, Time & Place | Ishvaram",
    description:
      "Free Lagna calculator: enter birth date, exact time and birthplace to find your Vedic ascendant sign, Lagna degree, Moon sign context and 1st house.",
    keywords: [
      "ascendant calculator",
      "lagna calculator",
      "lagna by date of birth",
      "rising sign calculator",
      "ascendant sign calculator",
      "lagna calculator free",
    ],
    ogTitle: "Lagna Calculator — Free Ascendant Sign by Birth Date | Ishvaram",
    ogDescription:
      "Find your exact Lagna + lord + nakshatra pada in 30 seconds. Accurate Vedic calculations.",
  },
  "nakshatra-calculator": {
    title: "Free Nakshatra Calculator | Birth Star Finder | Ishvaram",
    description:
      "Find your Nakshatra (birth star) and pada by date of birth. 100% free — get your Janma Nakshatra, ruling planet, deity, and name syllables.",
    keywords: [
      "nakshatra calculator",
      "birth star",
      "janma nakshatra",
      "nakshatra finder",
      "nakshatras devaganas",
      "deva gana nakshatra",
    ],
  },
  "rashi-calculator": {
    title: "Free Rashi Calculator | Moon Sign by Date of Birth | Ishvaram",
    description:
      "Enter your date of birth and find your Rashi (Moon Sign) in seconds. Free Vedic Rashi calculator — instantly shows your rashi lord, element, ruling nakshatra, and compatibility. No signup needed.",
    keywords: ["rashi calculator", "moon sign calculator", "rashi by date of birth", "janma rashi"],
  },
  "mangal-dosha-calculator": {
    title: "Manglik Calculator — Free Mangal Dosh Check by Date of Birth | Ishvaram",
    description:
      "Check Mangal Dosha (Mangalik) in your birth chart free. Get dosha intensity, classical remedies, and Mangalik compatibility analysis.",
    keywords: [
      "mangal dosha calculator",
      "mangalik check",
      "mangal dosha free",
      "kuja dosha",
      "mangal dosh",
      "manglik dosh",
      "mangalik dosha check",
      "am i manglik",
    ],
  },
  "pitra-dosh-calculator": {
    title: "Pitra Dosh Calculator | Free Pitra Dosha Check | Ishvaram",
    description:
      "Check Pitra Dosh (पितृ दोष) in your birth chart free. Get instant Sun/node affliction analysis, severity, and ancestral karma remedies — tarpan, shraddh & Vedic upay.",
    keywords: [
      "pitra dosh calculator",
      "pitra dosha check",
      "pitra dosh free",
      "ancestral dosha calculator",
      "pitru dosh",
      "pitra dosh upay",
      "pitra dosha symptoms",
      "9th house affliction",
    ],
  },
  "dasha-calculator": {
    title:
      "Vimshottari Dasha Calculator — See Your Current Mahadasha & Antardasha (Free) | Ishvaram",
    description:
      "Enter your birth date to see your current Mahadasha and Antardasha, plus the full 120-year Vimshottari timeline with exact dates for all 9 planet periods.",
    keywords: [
      "dasha calculator",
      "mahadasha calculator",
      "vimshottari dasha calculator",
      "current mahadasha",
      "vimshottari dasha",
      "antardasha",
      "mahadasha by date of birth",
      "mahadasha antardasha calculator",
      "vimshottari dashas",
    ],
    ogTitle: "Vimshottari Dasha — Your Current Mahadasha & Antardasha | Ishvaram",
    ogDescription:
      "See which Mahadasha + Antardasha you're in right now. Full 120-year timeline with exact dates.",
  },
  "gun-milan": {
    title: "Gun Milan Calculator — Free Kundali Matching, 36 Ashtakoot | Ishvaram",
    description:
      "Free Gun Milan calculator — full 36-point Ashtakoot kundali matching with all 8 kootas, Mangal Dosh & Nadi Dosh check, and a clear marriage compatibility verdict. Enter both birth details and get the score instantly.",
    keywords: [
      "gun milan",
      "kundali matching",
      "ashtakoot",
      "36 gun milan",
      "marriage compatibility",
      "patrika matching",
      "janmakshar matching",
      "match making kundali",
    ],
  },
  "tithi-today": {
    title: "Aaj Ki Tithi — Today's Hindu Tithi Date | Ishvaram",
    description:
      "Today's Tithi (lunar day) in Hindu calendar — Paksha, Tithi name, significance, and what it means for your day. Accurate Tithi for all 30 lunar days with Vedic guidance.",
    keywords: [
      "tithi today",
      "aaj ki tithi",
      "today tithi",
      "tithi for today",
      "todays tithi",
      "hindu tithi today",
      "aaj ka tithi",
      "tithi 2026",
      "paksha tithi",
    ],
    ogTitle: "Aaj Ki Tithi — Today's Hindu Tithi | Ishvaram",
    ogDescription:
      "Today's Tithi, Paksha, and significance. Accurate Hindu lunar calendar day — free.",
  },
  "shani-transit": {
    title: "Shani Transit {prevyear}-{year} | Saturn Current Position & Affected Rashis | Ishvaram",
    description:
      "Saturn (Shani) current transit position, which Moon signs are affected, Sade Sati status {prevyear}-{year}. Check how Shani Gochar impacts your rashi — free.",
    keywords: [
      "shani transit",
      "shani gochar",
      "saturn transit",
      "shani transit {year}",
      "shani transit {prevyear}",
      "saturn current position",
      "shani grah gochar",
      "shani ki sthiti",
    ],
    ogTitle: "Shani Transit {prevyear}-{year} | Saturn Position & Affected Rashis",
    ogDescription:
      "Saturn's current rashi, degree, and which Moon signs are under Sade Sati right now. Free transit check.",
  },
  "sade-sati": {
    title: "Sade Sati Calculator — Why Life Feels Stuck Right Now (Free Check & Upay) | Ishvaram",
    description:
      "Why does everything feel like an uphill struggle lately? Shani's Sade Sati transit over your Moon sign is the reason. Free check — find your phase (rising, peak, setting), how long it lasts, and your upay.",
    keywords: [
      "sade sati calculator",
      "sade sati",
      "shani sade sati",
      "saturn transit moon",
      "sade sati by date of birth",
      "sade sati current phase",
    ],
  },
  transits: {
    title: "Grah Gochar {year} | Saturn & Jupiter Transit | Ishvaram",
    description:
      "Check today's planetary transits — Saturn (Shani), Jupiter (Guru), Rahu-Ketu current positions. Free Sade Sati check and transit predictions.",
    keywords: [
      "grah gochar",
      "planetary transits",
      "shani gochar",
      "guru gochar",
      "rahu ketu transit",
    ],
  },
  remedies: {
    title: "Dosha Remedies | Personalized Vedic Astrology Remedies | Ishvaram",
    description:
      "Get personalized dosha remedies based on your birth chart. Detect Mangal Dosha, Kaal Sarp Dosha, Shani Dosha, and more — with specific remedies, mantras, and gemstones.",
    keywords: [
      "dosha remedies",
      "vedic astrology remedies",
      "mangal dosha remedy",
      "kaal sarp remedy",
    ],
  },
  compatibility: {
    title: "Rashi Compatibility | Zodiac Sign Matching | Ishvaram",
    description:
      "Check compatibility between all 144 Rashi combinations. Vedic astrology compatibility analysis for love, marriage, and friendship.",
    keywords: [
      "rashi compatibility",
      "zodiac compatibility",
      "rashi matching",
      "astrology compatibility",
    ],
  },

  "ai-kundli": {
    title: "Free AI Kundli | AI-Powered Janam Kundali Online | Ishvaram",
    description:
      "Generate your Janam Kundali instantly with our AI Kundli calculator. Get instant kundali analysis, planet positions, house meanings & predictions\u2014100% free.",
    keywords: [
      "AI kundli",
      "AI kundali",
      "AI janam kundali",
      "kundli AI",
      "AI birth chart",
      "AI astrology calculator",
    ],
    ogTitle: "Free AI Kundli | AI-Powered Janam Kundali Online | Ishvaram",
    ogDescription: "Generate your Janam Kundali instantly with our AI Kundli calculator.",
  },
  "birth-chart": {
    title: "Free Vedic Birth Chart Calculator | Janam Kundali | Ishvaram",
    description:
      "Calculate your Vedic birth chart instantly. Get accurate planetary positions, house analysis, and detailed kundali interpretation\u2014100% free.",
    keywords: [
      "birth chart calculator",
      "janam kundali",
      "vedic birth chart",
      "kundali calculator",
      "natal chart vedic",
      "free birth chart",
    ],
  },
  calendar: {
    title: "Hindu Calendar {year}-{nextyear} | Festival & Vrat Dates | Ishvaram",
    description:
      "Hindu Calendar {year}-{nextyear} with festival dates, vrat (fasting) schedules, auspicious timings, and rituals for all Hindu holidays.",
    keywords: [
      "hindu calendar",
      "hindu festival dates",
      "vrat calendar",
      "festival schedule {year}",
      "hindu holidays {year}",
      "auspicious dates",
    ],
  },
  dosha: {
    title: "Doshas in Vedic Astrology | Mangal Dosha, Kaal Sarp & More | Ishvaram",
    description:
      "Understand Doshas in Vedic astrology including Mangal Dosha, Kaal Sarp Dosha, Pitra Dosha. Check your birth chart for doshas and remedies.",
    keywords: [
      "dosha vedic astrology",
      "mangal dosha",
      "kaal sarp dosha",
      "pitra dosha",
      "doshas in astrology",
      "dosha remedies",
    ],
  },
  graha: {
    title: "9 Grahas (Planets) in Vedic Astrology \u2014 Navagraha Guide | Ishvaram",
    description:
      "Learn about the 9 Grahas (planets) in Vedic astrology: Sun, Moon, Mars, Mercury, Jupiter, Venus, Saturn, Rahu & Ketu. Understand their meanings and effects.",
    keywords: [
      "grahas vedic astrology",
      "navagraha",
      "planets vedic",
      "sun moon mars",
      "jupiter saturn",
      "rahu ketu",
      "planetary positions",
    ],
  },
  "kaal-sarp-dosh": {
    title: "Kaal Sarp Dosh Calculator — Check Your Kundali Free | Ishvaram",
    description:
      "Is Kaal Sarp Dosh in your birth chart? Enter your birth details for a free, instant check — engine-computed from your planetary positions. Find your sub-type (Anant to Sheshnag) and see classical upay.",
    keywords: [
      "kaal sarp dosh",
      "kaal sarp dosh calculator",
      "kaal sarp dosh check",
      "kaal sarp dosh in kundali",
      "kaal sarp dosha check free",
      "kaal sarp yoga calculator",
    ],
    ogTitle: "Kaal Sarp Dosh Calculator — Free Check | Ishvaram",
    ogDescription:
      "Find out if all planets in your kundali are trapped between Rahu and Ketu. Free Kaal Sarp Dosh check with sub-type and upay.",
  },
  "kaal-sarp-dosha": {
    title: "Kaal Sarp Dosh — Why Success Always Slips Away (12 Types, Symptoms & Upay) | Ishvaram",
    description:
      "Why does success come close then slip away? When all your planets sit trapped between the Rahu-Ketu axis, Kaal Sarp Dosh creates this ceiling. Free kundali check — find your type and the classical upay.",
    keywords: [
      "kaal sarp dosha",
      "kaal sarp dosh",
      "12 types of kaal sarp dosh",
      "kaal sarp dosh check",
      "kaal sarp dosh types",
      "kaal sarp symptoms",
      "kaal sarp remedy",
    ],
  },
  "lal-kitab": {
    title: "Lal Kitab | Free Reading, Remedies & Rin Analysis | Ishvaram",
    description:
      "Free Lal Kitab reading online — house-based planetary analysis, Rin (karmic debt) detection, and authentic upay (remedies) for every planet. Check your chart with Pt. Roop Chand Joshi's Lal Kitab principles.",
    keywords: [
      "lal kitab",
      "lal kitab remedies",
      "lal kitab kundli",
      "lal kitab upay",
      "lal kitab rin",
      "lal kitab astrology",
      "lal kitab reading",
      "लाल किताब",
    ],
    ogTitle: "Free Lal Kitab Reading — House-Based Remedies | Ishvaram",
    ogDescription:
      "Authentic Lal Kitab analysis: every planet, every house, every upay. Free Kundali + Rin check + remedies.",
  },
  "pitra-dosha": {
    title: "Pitra Dosh — Why Misfortune Follows Your Family (Symptoms & Upay) | Ishvaram",
    description:
      "Why does misfortune keep returning in your family — money, health, marriage? Pitra Dosh, the karmic debt of ancestral matters, leaves this imprint. Free check for Sun-Rahu/Ketu affliction, plus tarpan & shraddh upay.",
    keywords: [
      "pitra dosha",
      "pitra dosh",
      "pitra dosha remedies",
      "pitra dosha symptoms",
      "ancestral dosha",
      "pitru dosh",
      "9th house dosha",
      "पितृ दोष",
    ],
    ogTitle: "Pitra Dosh — Ancestral Karmic Debt & Upay | Ishvaram",
    ogDescription:
      "Detect Pitra Dosha in your chart. Understand symptoms. Perform the right tarpan + upay. Free Vedic analysis.",
  },
  upay: {
    title: "Upay — Vedic Astrology Remedies | Mantra, Daan, Gemstone Upay | Ishvaram",
    description:
      "Complete guide to upay (उपाय) in Vedic astrology — mantra, daan, vrat, gemstone, and sacred item remedies for Shani, Rahu, Mangal, Ketu, Kaal Sarp Dosh, and Pitra Dosh. Learn which upay is right for your chart.",
    keywords: [
      "upay",
      "vedic astrology upay",
      "jyotish upay",
      "shani upay",
      "rahu upay",
      "mangal upay",
      "kaal sarp upay",
      "pitra dosh upay",
      "dosha remedies",
      "vedic remedies",
      "graha upay",
      "upay in astrology",
      "ज्योतिष उपाय",
    ],
    ogTitle: "Upay — Vedic Astrology Remedies for Doshas | Ishvaram",
    ogDescription:
      "Mantra, daan, vrat, gemstone & sacred item upay for Shani, Rahu, Mangal, Ketu & all doshas. Find the right upay for your chart.",
  },
  ashtakvarga: {
    title: "Ashtakvarga | Sarvashtakvarga Bindu Chart & Reading | Ishvaram",
    description:
      "Ashtakvarga (अष्टकवर्ग) system: the Vedic bindu-based method for measuring planetary strength in every house. Get your Sarvashtakvarga chart, transit predictions, and timing analysis. Free calculation.",
    keywords: [
      "ashtakvarga",
      "sarvashtakvarga",
      "ashtakvarga chart",
      "bindu vedic astrology",
      "planetary strength",
      "transit prediction",
      "अष्टकवर्ग",
    ],
    ogTitle: "Ashtakvarga — Planetary Strength Chart | Ishvaram",
    ogDescription:
      "Bindu-by-bindu planetary strength reading. Free Sarvashtakvarga table and transit analysis.",
  },
  varshphal: {
    title: "Varshphal | Free Solar Return Yearly Horoscope (Tajik) | Ishvaram",
    description:
      "Varshphal (वर्षफल) — the Tajik solar return system for your yearly horoscope. Muntha, Varsh Lagna, Muddha dasha, and the 16 yogas that rule your year. Free analysis of your current solar return.",
    keywords: [
      "varshphal",
      "solar return",
      "tajik astrology",
      "yearly horoscope",
      "annual chart",
      "muntha",
      "varsh lagna",
      "वर्षफल",
    ],
    ogTitle: "Varshphal — Your Vedic Yearly Horoscope | Ishvaram",
    ogDescription:
      "Free Tajik Varshphal reading — Muntha, Muddha dasha, and the 16 yogas of your year.",
  },
  "kp-astrology": {
    title: "KP Astrology | Krishnamurti Paddhati Sub-Lord System | Ishvaram",
    description:
      "KP astrology (Krishnamurti Paddhati) — the stellar sub-lord system for precise event timing. Understand sub-lords, significators, ruling planets, and how KP differs from Parashari. Free KP chart analysis.",
    keywords: [
      "kp astrology",
      "krishnamurti paddhati",
      "kp system",
      "sub lord astrology",
      "kp chart",
      "kp reading",
      "stellar astrology",
      "कृष्णमूर्ति पद्धति",
    ],
    ogTitle: "KP Astrology — Sub-Lord System Reading | Ishvaram",
    ogDescription:
      "Precise event timing via KP sub-lords. Free Krishnamurti Paddhati chart + reading.",
  },
  vastu: {
    title: "Vastu Shastra | Free Analysis, Room Placement & Remedies | Ishvaram",
    description:
      "Free Vastu Shastra analysis — room placement by direction, common doshas, traditional remedies, and 9x9 Vastu Purusha Mandala guidance.",
    keywords: [
      "vastu",
      "vastu shastra",
      "vastu tips",
      "vastu for home",
      "vastu dosha",
      "vastu remedies",
      "vastu directions",
      "वास्तु शास्त्र",
    ],
    ogTitle: "Vastu Shastra — Free Directional Analysis | Ishvaram",
    ogDescription:
      "Directional Vastu analysis + remedies. Classical 9x9 Mandala principles, free and instant.",
  },
  "monthly-rashifal": {
    title: "Monthly Rashifal — Masik Horoscope for 12 Rashi | Ishvaram",
    description:
      "Free Masik Rashifal (monthly horoscope) for all 12 zodiac signs. Career, health, love, finance predictions and key dates for the month \u2014 100% free.",
    keywords: [
      "monthly rashifal",
      "masik rashifal",
      "monthly horoscope",
      "this month rashifal",
      "monthly horoscope vedic",
    ],
  },
  nakshatra: {
    title: "27 Nakshatras — Vedic Birth Star Guide | Ishvaram",
    description:
      "All 27 Nakshatras in Vedic astrology \u2014 ruling planets, personality traits, career paths, marriage compatibility and Vedic remedies. Free nakshatra calculator included.",
    keywords: [
      "nakshatra",
      "birth star",
      "27 nakshatras",
      "nakshatra meanings",
      "nakshatra calculator",
      "moon nakshatra",
      "nakshatra characteristics",
      "nakshatra personality",
    ],
  },
  "nakshatra/chitra-female": {
    title: "Chitra Nakshatra Female \u2014 Personality, Career, Marriage & Compatibility",
    description:
      "Chitra Nakshatra female personality, career prospects, marriage compatibility, and life predictions. Understand traits and best matches for Chitra females.",
    keywords: [
      "chitra nakshatra female",
      "chitra nakshatra woman",
      "chitra nakshatra personality",
      "chitra nakshatra marriage",
    ],
  },
  "nakshatra/purva-ashadha": {
    title: "Purva Ashadha Nakshatra \u2014 Personality, Career, Marriage & Compatibility",
    description:
      "Purva Ashadha Nakshatra personality, career, marriage compatibility, and life predictions. Learn about traits, strength and best matches.",
    keywords: [
      "purva ashadha nakshatra",
      "purva ashadha star",
      "purva ashadha personality",
      "purva ashadha compatibility",
    ],
  },
  "nakshatra/purva-phalguni": {
    title: "Purva Phalguni Nakshatra \u2014 Personality, Career, Marriage & Compatibility",
    description:
      "Purva Phalguni Nakshatra personality, career, marriage compatibility, and life predictions. Understand personality traits and best matches.",
    keywords: [
      "purva phalguni nakshatra",
      "purva phalguni star",
      "purva phalguni personality",
      "purva phalguni compatibility",
    ],
  },
  "nakshatra/pushya-female": {
    title: "Pushya Nakshatra Female \u2014 Personality, Career, Marriage & Compatibility",
    description:
      "Pushya Nakshatra female personality, career prospects, marriage compatibility, and life predictions.",
    keywords: [
      "pushya nakshatra female",
      "pushya nakshatra woman",
      "pushya nakshatra personality",
      "pushya nakshatra compatibility",
    ],
  },
  "nakshatra/shatabhisha-female": {
    title: "Shatabhisha Nakshatra Female \u2014 Personality, Career, Marriage & Compatibility",
    description:
      "Shatabhisha Nakshatra female personality, career prospects, marriage compatibility, and life predictions.",
    keywords: [
      "shatabhisha nakshatra female",
      "shatabhisha nakshatra woman",
      "shatabhisha nakshatra personality",
      "shatabhisha nakshatra marriage",
    ],
  },
  "nakshatra/uttara-bhadrapada-female": {
    title:
      "Uttara Bhadrapada Nakshatra Female \u2014 Personality, Career, Marriage & Compatibility",
    description:
      "Uttara Bhadrapada Nakshatra female personality, career prospects, marriage compatibility, and life predictions.",
    keywords: [
      "uttara bhadrapada nakshatra female",
      "uttara bhadrapada woman",
      "uttara bhadrapada traits",
      "uttara bhadrapada marriage",
    ],
  },
  "nakshatra/uttara-phalguni-compatibility": {
    title: "Uttara Phalguni Nakshatra Compatibility \u2014 Best Matches & Marriage",
    description:
      "Uttara Phalguni Nakshatra compatibility guide for marriage and relationships. Find best matches and understand compatibility traits.",
    keywords: [
      "uttara phalguni compatibility",
      "uttara phalguni marriage",
      "uttara phalguni nakshatra",
      "nakshatra compatibility",
    ],
  },
  "nakshatra/purva-bhadrapada": {
    title: "Purva Bhadrapada Nakshatra \u2014 Personality, Career, Marriage & Remedies | Ishvaram",
    description:
      "Complete guide to Purva Bhadrapada Nakshatra (25th nakshatra). Ruled by Jupiter in Aquarius-Pisces. Personality traits, male & female characteristics, career, marriage compatibility, 4 padas, and remedies.",
    keywords: [
      "purva bhadrapada nakshatra",
      "purva bhadrapada",
      "purva bhadrapada personality",
      "purva bhadrapada male",
      "purva bhadrapada female",
      "purva bhadrapada compatibility",
    ],
  },
  "nakshatra/mrigashira-characteristics": {
    title:
      "Mrigashira Nakshatra Characteristics \u2014 Personality, Career & Compatibility | Ishvaram",
    description:
      "Mrigashira Nakshatra characteristics \u2014 the eternal seeker. Ruled by Mars in Taurus-Gemini. Personality traits, male & female tendencies, career paths, marriage compatibility, and Vedic remedies.",
    keywords: [
      "mrigashira nakshatra characteristics",
      "mrigashira nakshatra",
      "mrigashira personality",
      "mrigashira compatibility",
      "mrigashira nakshatra male",
      "mrigashira nakshatra female",
    ],
  },
  "nakshatra/anuradha-male": {
    title: "Anuradha Nakshatra Male \u2014 Personality, Career & Marriage | Ishvaram",
    description:
      "Anuradha Nakshatra male characteristics \u2014 devoted, disciplined, born leaders. Ruled by Saturn in Scorpio. Understand personality, career tendencies, marriage compatibility, and Vedic remedies for Anuradha males.",
    keywords: [
      "anuradha nakshatra male",
      "anuradha nakshatra man",
      "anuradha nakshatra personality",
      "anuradha nakshatra career",
      "anuradha nakshatra marriage",
    ],
  },
  "nakshatra/punarvasu-male": {
    title: "Punarvasu Nakshatra Male \u2014 Personality, Career & Marriage | Ishvaram",
    description:
      "Punarvasu Nakshatra male characteristics \u2014 optimistic, philosophical, natural teachers. Ruled by Jupiter in Gemini-Cancer. Personality, career, marriage compatibility, and Vedic remedies for Punarvasu males.",
    keywords: [
      "punarvasu nakshatra male",
      "punarvasu nakshatra man",
      "punarvasu nakshatra personality",
      "punarvasu nakshatra career",
      "punarvasu nakshatra marriage",
    ],
  },
  "nakshatra/dhanishta-male": {
    title: "Dhanishta Nakshatra Male \u2014 Personality, Career & Marriage | Ishvaram",
    description:
      "Dhanishta Nakshatra male characteristics \u2014 ambitious, musical, wealth-builders. Ruled by Mars in Capricorn-Aquarius. Personality, career, marriage tendencies, and Vedic remedies for Dhanishta males.",
    keywords: [
      "dhanishta nakshatra male",
      "dhanishta nakshatra man",
      "dhanishta nakshatra personality",
      "dhanishta nakshatra career",
      "dhanishta nakshatra marriage",
    ],
  },
  notifications: {
    title: "Notification Settings | Ishvaram Jyotish",
    description:
      "Manage your notification preferences for personalized astrology updates, predictions, and reminders.",
  },
  prashna: {
    title: "Prashna Kundali \u2014 Ask Any Question Free | Horary Astrology | Ishvaram",
    description:
      "Ask any life question and get instant answers using Prashna Kundali (horary astrology). Free prashna calculator for all your questions.",
    keywords: [
      "prashna kundali",
      "horary astrology",
      "ask question astrology",
      "prashna calculator",
      "prashna astrology",
    ],
  },
  rashi: {
    title: "All 12 Rashis in Vedic Astrology \u2014 Personality, Traits & Compatibility | Ishvaram",
    description:
      "Which Rashi are you? Find your Moon sign free by date of birth. All 12 Rashis explained \u2014 ruling planets, personality traits, compatible rashis, nakshatras, and what your Chandra Rashi reveals about you.",
    keywords: [
      "rashi",
      "12 rashis",
      "rashi personality",
      "rashi traits",
      "rashi compatibility",
      "chandra rashi",
      "moon sign vedic astrology",
      "vedic zodiac signs",
    ],
  },
  tarot: {
    title: "Free Daily Tarot Card Reading | AI Tarot Predictions | Ishvaram",
    description:
      "Get your free daily tarot card reading and predictions. AI-powered tarot interpretation for love, career, health, and life guidance.",
    keywords: [
      "tarot reading",
      "daily tarot",
      "tarot card reading",
      "free tarot",
      "tarot predictions",
    ],
  },
  mantras: {
    title: "Graha Mantra Upay — Vedic Mantras for All 9 Planets | Ishvaram",
    description:
      "Vedic mantra upay for all 9 grahas — Surya, Chandra, Mangal, Budh, Guru, Shukra, Shani, Rahu, Ketu. Beej mantras, Vedic mantras, jaap method, and classical remedies.",
    keywords: [
      "graha mantra",
      "vedic mantra",
      "shani mantra",
      "rahu mantra",
      "surya mantra",
      "chandra mantra",
      "mangal mantra",
      "budh mantra",
      "guru mantra",
      "shukra mantra",
      "ketu mantra",
      "mantra upay",
      "beej mantra",
      "navagraha mantra",
    ],
    ogTitle: "Graha Mantra Upay for All 9 Navagraha | Ishvaram",
    ogDescription:
      "Beej mantras, Vedic mantras, and jaap method for all 9 grahas. Classical Jyotish upay for Shani, Rahu, Mangal, and more.",
  },
  "mantras/surya": {
    title: "Surya Mantra — Beej Mantra for Sun, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Surya mantra guide — Om Hraam Hreem Hraum Sah Suryaya Namah beej mantra, Rigveda Vedic mantra, Surya Gayatri. Jaap method and upay for weak or afflicted Sun in kundali.",
    keywords: [
      "surya mantra",
      "sun mantra vedic",
      "surya beej mantra",
      "om suryaya namah",
      "surya mantra 108 times",
      "surya upay",
      "weak sun in kundali",
    ],
  },
  "mantras/chandra": {
    title: "Chandra Mantra — Beej Mantra for Moon, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Chandra mantra guide — Om Shraam Shreem Shraum Sah Chandramase Namah beej mantra. Jaap method, best day, and upay for weak or afflicted Moon in kundali.",
    keywords: [
      "chandra mantra",
      "moon mantra vedic",
      "chandra beej mantra",
      "om chandramase namah",
      "chandra mantra 108",
      "chandra upay",
      "weak moon kundali",
    ],
  },
  "mantras/mangal": {
    title: "Mangal Mantra — Beej Mantra for Mars, Mangal Dosh Upay | Ishvaram",
    description:
      "Complete Mangal mantra guide — Om Kraam Kreem Kraum Sah Bhaumaya Namah beej mantra. Jaap method and upay for Mangal Dosh and afflicted Mars in kundali.",
    keywords: [
      "mangal mantra",
      "mars mantra vedic",
      "mangal beej mantra",
      "mangal dosh upay mantra",
      "om bhaumaya namah",
      "mangal shanti mantra",
      "mangal mantra 108 times",
    ],
  },
  "mantras/budh": {
    title: "Budh Mantra — Beej Mantra for Mercury, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Budh mantra guide — Om Braam Breem Braum Sah Budhaya Namah beej mantra. Jaap method and upay for weak or combust Mercury (Budh) in kundali.",
    keywords: [
      "budh mantra",
      "mercury mantra vedic",
      "budh beej mantra",
      "om budhaya namah",
      "budh shanti mantra",
      "mercury mantra jyotish",
      "budh graha mantra",
    ],
  },
  "mantras/guru": {
    title: "Guru Mantra — Beej Mantra for Jupiter, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Guru (Jupiter) mantra guide — Om Graam Greem Graum Sah Gurave Namah beej mantra. Jaap method and upay for weak Jupiter and Guru Chandal Yoga.",
    keywords: [
      "guru mantra",
      "jupiter mantra vedic",
      "guru beej mantra",
      "brihaspati mantra",
      "om gurave namah",
      "guru shanti mantra",
      "jupiter mantra jyotish",
    ],
  },
  "mantras/shukra": {
    title: "Shukra Mantra — Beej Mantra for Venus, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Shukra (Venus) mantra guide — Om Draam Dreem Draum Sah Shukraya Namah beej mantra. Jaap method and upay for weak Venus and relationship problems.",
    keywords: [
      "shukra mantra",
      "venus mantra vedic",
      "shukra beej mantra",
      "om shukraya namah",
      "shukra shanti mantra",
      "venus mantra jyotish",
      "shukra graha upay",
    ],
  },
  "mantras/shani": {
    title: "Shani Mantra — Beej Mantra for Saturn, Sade Sati Upay | Ishvaram",
    description:
      "Complete Shani mantra guide — Om Praam Preem Praum Sah Shanaischaraya Namah beej mantra. Jaap method and upay for Shani Mahadasha, Sade Sati, and afflicted Saturn.",
    keywords: [
      "shani mantra",
      "saturn mantra vedic",
      "shani beej mantra",
      "om shanaischaraya namah",
      "sade sati mantra upay",
      "shani shanti mantra",
      "shani mantra 108 times",
      "shani graha upay",
    ],
  },
  "mantras/rahu": {
    title: "Rahu Mantra — Beej Mantra for Rahu, Kaal Sarp Dosh Upay | Ishvaram",
    description:
      "Complete Rahu mantra guide — Om Bhraam Bhreem Bhraum Sah Rahave Namah beej mantra. Jaap method and upay for Rahu Mahadasha, Kaal Sarp Dosh, and Rahu affliction.",
    keywords: [
      "rahu mantra",
      "rahu beej mantra",
      "om rahave namah",
      "kaal sarp dosh mantra upay",
      "rahu shanti mantra",
      "rahu mantra 108 times",
      "rahu graha upay",
    ],
  },
  "mantras/ketu": {
    title: "Ketu Mantra — Beej Mantra for Ketu, Jaap Method & Upay | Ishvaram",
    description:
      "Complete Ketu mantra guide — Om Sraam Sreem Sraum Sah Ketave Namah beej mantra. Jaap method and upay for Ketu Mahadasha, Kaal Sarp Dosh, and spiritual detachment.",
    keywords: [
      "ketu mantra",
      "ketu beej mantra",
      "om ketave namah",
      "ketu shanti mantra",
      "ketu mantra 108 times",
      "ketu graha upay",
      "ketu mahadasha upay",
    ],
  },
  ...enVrat,
  ...enLongTail,
};

export default en;

// ---------------------------------------------------------------------------
// Cookie consent banner copy — separate from PageMeta (not SEO metadata)
// ---------------------------------------------------------------------------
export interface CookieConsentCopy {
  title: string;
  body: string;
  acceptAll: string;
  rejectAll: string;
  customize: string;
  customizeClose: string;
  essentialHeading: string;
  essentialDetail: string;
  analyticsHeading: string;
  analyticsDetail: string;
  ariaLabel: string;
}

export const cookieConsent: CookieConsentCopy = {
  title: "Analytics choices",
  body: "Optional product analytics help improve Ishvaram.",
  acceptAll: "Allow",
  rejectAll: "No thanks",
  customize: "Customize",
  customizeClose: "Close",
  essentialHeading: "Essential (always on)",
  essentialDetail:
    "Sentry error tracking — keeps the site running. No personal data leaves India-region servers.",
  analyticsHeading: "Analytics (optional)",
  analyticsDetail:
    "First-party analytics and marketing tags — helps us improve Kundali, Rashifal, and Panchang tools. No cross-site tracking.",
  ariaLabel: "Cookie consent",
};
